export const Breadcrumbs = {
    Employee: {
        Base: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Employee', disabled: true, href: '#/employee' },
        ],
        Edit: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Employee', disabled: false, href: '#/employee'},
            {text: 'Edit', disabled: true, href: '#/employee/:id'},
        ],
        Me: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'My Info', disabled: true, to: 'me'},
        ],
        MyTasks: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'My Tasks', disabled: true, to: 'me'},
        ],
        MyBenefits: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'My Benefits', disabled: true, to: '#/employee/myBenefits'},
        ],
        // MyBenefitDetails: [
        //     {text: 'Dashboard', disabled: false, href: '#/dashboard'},
        //     {text: 'My Benefits', disabled: true, to: '#/employee/myBenefits'},
        //     {text: 'Details', disabled: true, to: 'me'},
        // ],
        Profile: [
            { text: "Dashboard", disabled: false, href: "#/dashboard" },
            { text: "Employee", disabled: false, href: "#/employee" },
            { text: "Profile", disabled: true, href: "#/employee/profile/:id" }
        ]
    },
    Benefit: {
        Provider: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Provider management', disabled: true, href: '#/benefit/provider'},
        ],
        ProviderProfile: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Marketplace', disabled: false, href: '#/benefit/marketplace'},
            {text: 'Provider profile', disabled: true, href: '#/provider/:id'},
        ],
        Marketplace: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Marketplace', disabled: true, href: '#/benefit/marketplace'},
        ],
        List: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Benefits manager', disabled: true, href: '#/benefit/list'},
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
            { text: 'Add', disabled: true, href: '#/benefit/list' },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
            { text: 'Edit', disabled: true, href: '#/benefit/list' },
        ],
        Info: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
            { text: 'Info', disabled: true, href: '#/benefit/list' },
        ],
        Details: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Marketplace', disabled: false, href: '#/benefit/marketplace'},
            {text: 'Offer details', disabled: true, href: '#/benefit/list'},
        ],
        Pension: {
            Add: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                {
                    text: 'Add Pension Benefit',
                    disabled: true,
                    href: '#/benefit/pension/add',
                },
            ],
            Edit: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                {
                    text: 'Edit Pension Benefit',
                    disabled: true,
                    href: '#/benefit/pension/edit',
                },
            ],
        },
        Insurance: {
            Add: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                {
                    text: 'Add Insurance Benefit',
                    disabled: true,
                    href: '#/benefit/insurance/add',
                },
            ],
            Edit: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                {
                    text: 'Edit Insurance Benefit',
                    disabled: true,
                    href: '#/benefit/insurance/edit',
                }],
        },
        Custom: {
            Add: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                { text: 'Add custom benefit', disabled: true, href: '#/benefit/list' },
            ],
            Edit: [
                { text: 'Dashboard', disabled: false, href: '#/dashboard' },
                { text: 'Company', disabled: false, href: '#/company' },
                { text: 'Benefits manager', disabled: false, href: '#/benefit/list' },
                {
                    text: 'Edit custom benefit',
                    disabled: true,
                    href: '#/benefit/custom/edit',
                }],
        },
    },
    Company: {
        Home: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Company', disabled: true, to: 'comp'},
        ],
        General: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Info', disabled: true},
        ],
    },
    Access: {
        List: [
            {text: 'Dashboard', disabled: false, href: "#/dashboard"},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Access management', disabled: true},
        ],
        Logs: [
            {text: 'Dashboard', disabled: false, href: "#/dashboard"},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Access logs', disabled: true},
        ]
    },
    Leaves: {
        List: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Leaves', disabled: true},
        ],
        Add: [
            {text: 'Dashboard', disabled: false, href: '#/dashboard'},
            {text: 'Company', disabled: false, href: '#/company'},
            {text: 'Leaves', disabled: false, href: '#/company/leaves'},
            { text: 'Add', disabled: true },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Leaves', disabled: false, href: '#/company/leaves' },
            { text: 'Edit', disabled: true },
        ],
    },
    Locations: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Locations', disabled: true },
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Locations', disabled: false, href: '#/company/locations' },
            { text: 'Add', disabled: true },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Locations', disabled: false, href: '#/company/locations' },
            { text: 'Edit', disabled: true },
        ],
    },
    Departments: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Departments', disabled: true },
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Departments', disabled: false, href: '#/company/departments' },
            { text: 'Add', disabled: true },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Departments', disabled: false, href: '#/company/departments' },
            { text: 'Edit', disabled: true },
        ],
    },
    Workflows: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Workflows', disabled: true },
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Workflows', disabled: false, href: '#/company/workflows' },
            { text: 'Add', disabled: true },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Workflows', disabled: false, href: '#/company/workflows' },
            { text: 'Edit', disabled: true },
        ],
    },
    WorkflowToDos: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'WorkflowToDos', disabled: true },
        ],
    },
    Announcement: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Announcement', disabled: true, href: '#/announcements' },
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Announcement', disabled: false, href: '#/announcements' },
            { text: 'Add', disabled: true, href: '#' },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Announcement', disabled: false, href: '#/announcements' },
            { text: 'Edit', disabled: true, href: '#' },
        ],
        ReadOnly: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Announcement', disabled: false, href: '#/announcements' },
            { text: 'Info', disabled: true, href: '#' },
        ]
    },
    TimeOff: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Time off', disabled: true, href: '#/timeOff/list' },
        ],
        Approve: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Approve time off', disabled: true, href: '#/timeOff/approve' },
        ],
        Details: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Timeoff', disabled: false, href: '#/timeoff/list' },
            { text: 'Details', disabled: true, href: '' },
        ],
    },
    Calendar: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Calendar', disabled: true, href: '#/company/calendar' },
        ],
    },
    Backoffice: {
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Backoffice', disabled: true, href: '#/backoffice' },
        ],
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Backoffice', disabled: false, href: '#/backoffice' },
            { text: 'Add', disabled: true, href: '#' },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Backoffice', disabled: false, href: '#/backoffice' },
            { text: 'Edit', disabled: true, href: '#' },
        ],
        ReadOnly: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Backoffice', disabled: false, href: '#/backoffice' },
            { text: 'Info', disabled: true, href: '#' },
        ]
    },
    MarketPlace: {
        Add: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Marketplace', disabled: false, href: '#/company/marketplace' },
            { text: 'Add', disabled: true, href: '#/marketplace/add' },
        ],
        Edit: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Marketplace', disabled: false, href: '#/company/marketplace' },
            { text: 'Edit', disabled: true, href: '#/marketplace/edit' },
        ],
        List: [
            { text: 'Dashboard', disabled: false, href: '#/dashboard' },
            { text: 'Company', disabled: false, href: '#/company' },
            { text: 'Marketplace', disabled: true, href: '#/company/marketplace' },
        ],
    },
    Membership: [
        { text: 'Dashboard', disabled: false, href: '#/dashboard' },
        { text: 'Membership', disabled: true, to: 'membership' },
    ],
};